import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { FollowedRegions } from './sections/following/FollowedRegions'
import { FollowedInitiatives } from './sections/following/FollowedInitiatives'
import { FollowedHousingForms } from './sections/following/FollowedHousingForms'
import { InitiativesPanel } from './sections/shared/InitiativesPanel'
import { FollowedPlots } from './sections/following/FollowedPlots'
import useMediaQuery from '@app/util/useMediaQuery'

export const ProfileFollowing = () => {
  const isMobile = useMediaQuery()
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.followed

  return (
    <DashboardPageLayout>
      <Title.H3>{translations.title}</Title.H3>
      <Row
        gap="1.5rem"
        style={{ alignItems: 'start', flexWrap: 'wrap', flexGrow: 0 }}
      >
        <Column
          alignItems="stretch"
          gap="2rem"
          style={{
            backgroundColor: 'var(--palette-white)',
            padding: '1.5rem 1rem',
            borderRadius: '1.25rem',
            flex: '1 1 30rem',
            minWidth: isMobile ? '100%' : '30rem',
          }}
        >
          <FollowedInitiatives />
          <FollowedPlots />
          <FollowedRegions />
          <FollowedHousingForms />
        </Column>
        <InitiativesPanel />
      </Row>
    </DashboardPageLayout>
  )
}
